export const adData = [
  {
    id: 1,
    name: '兵庫県 三田青磁と茶道体験ツアー',
    imageUrl: '三田陶芸の森広告バナー②.png ',
    link: 'https://jtc-net.co.jp/sanda-tougei-no-mori-tour2025',
  },
   {
    id: 2,
    name: 'Hyogo Prefecture: Sanda Celadon and Tea Ceremony Experience Tour',
    imageUrl: '三田陶芸の森広告バナー③.png ',
    link: 'https://jtc-net.co.jp/sanda-tougei-no-mori-tour2025?lang=en',
  },
];
